import { render, staticRenderFns } from "./ViewAdvertisement.vue?vue&type=template&id=702e4ac2&scoped=true"
import script from "./ViewAdvertisement.vue?vue&type=script&lang=js"
export * from "./ViewAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./ViewAdvertisement.vue?vue&type=style&index=0&id=702e4ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702e4ac2",
  null
  
)

export default component.exports